<template>
  <div>
    <div class="left_tree">
      <a-spin :spinning="treeSpin" style="height: 100%">
        <div>
          <vxe-button @click="add" style="margin:0 3px 10px 0">新增</vxe-button>
          <vxe-button @click="edit" style="margin:0 3px 10px 0">编辑</vxe-button>
          <vxe-button @click="del" style="margin:0 3px 10px 0">删除</vxe-button>
        </div>
        <a-tree
                :show-icon="true"
                :checkStrictly="true"
                :defaultExpandAll="false"
                :defaultExpandParent="true"
                :expandedKeys.sync="defaultExpandedKeys"
                :tree-data="deptList"
                :selectedKeys="selectedKeys"
                :replaceFields="{children:'children', title:'questionTypeName', key:'questionTypeId', value: 'questionTypeId' }"
                @select="onSelect"
                @check="onCheck"
        >
          <!--          :checkable="true"-->
          <a-icon type="team" slot="dealer" style="color:#2fcfeb"/>
          <a-icon type="cluster" slot="region" style="color:#52c41a"/>
        </a-tree>
      </a-spin>
    </div>
    <div class="right_table">
      <x-grid
          :id="'formList'"
          :rowId="rowId"
          :pager-config="pagerConfig"
          :form-config="formConfig"
          :url="url"
          :columns="columns"
          :other-params="{
            questionTypeId :questionTypeId
          }"
          :checkbox-config="checkboxConfig"
          :toolbar-config="toolbarConfig"
          :print-config="printConfig"
          :export-config="exportConfig"
          ref="grid"
          :cellClick="chooseRow"
          :cellDbClick="updateRow"
          @toolbar-addData="addRow"
          @toolbar-delData="delRow"
      >
        <template v-slot:[toolbarConfig.templatelSlots]>
          <vxe-button style="border: none;width: 126px">
            <a-upload
                name="file"
                :multiple="false"
                :accept="'.xlsx'"
                :action="api.answer.ANSWERUPLOAD"
                :headers="{token:token}"
                @change="importHandleChange"
            >
              <vxe-button>常见问答导入</vxe-button>
            </a-upload>
          </vxe-button>
          <vxe-button @click="download()">下载常见问答模板</vxe-button>
        </template>
      </x-grid>
    </div>

    <!--明细页表单简化通用写法-->
    <formModal title="常见问答" :visible="editModalVisible">
      <detailForm :rowId="editRowId"

                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)">
      </detailForm>
      <!--    :questionTypeId="questionTypeId"-->
    </formModal>

    <a-modal
        title="问题分组"
        :closable="true"
        :footer="null"
        :maskClosable="false"
        :visible="editQuestion"
        @cancel="closeQuestion()"
        :width="600"
    >
      <question :rowId="editQuestionId"
                :parentId="parentId"
                v-if="editQuestion"
                ref="editQuestion"
                @cancelled="closeQuestion()"
                @saved="closeQuestion(true)">
      </question>
    </a-modal>

  </div>
</template>

<script>
import {
  GridMixin,
  api,
  fac,
  mapState
} from "@/utils/common/XGridBase"

import {dataApi} from "@/services/question/question";
import {XEUtils} from "@/utils/common/FormBase";
import detailForm from "./questionDetail";
import question from "@/pages/web/answer/commonAnswer/detail/questionTreeDetail";
import axios from "axios";

//列表接口
const url = api.answer.QUESTION;

//主键
const rowId = "questionId";

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("questionName", "问题标题", 340),
  fac.makeColumn("createUserName", "创建者", 140),
  fac.makeColumn("keyWordsNames", "关键词", 140),
  fac.makeColumn("createDate", "创建时间", 140),
  fac.makeColumn("lastModifyDate", "最后修改时间", 140),
  fac.makeColumn("usedCount", "使用次数", 140),
];

// 筛选条件
const formConfig = fac.makeFormConfig(columns, [
  {field: "questionName"},
  {field: "keyWordsNames"}
]);

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  export: true,
  import: false,
  delData: true,
  addData: true,
  templatelSlots: "toolbarBtns",
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);


export default {
  mixins: [GridMixin],
  authorize: {},
  components: {
    detailForm,
    question
    // setPassword,
  },
  computed: {
    ...mapState("account", {currUser: "user"}),
  },
  mounted() {
    this.getQuestionTree();
  },
  data() {
    return {
      // popConfig,
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      checkedKeys: [],
      allList: [],
      deptList: [],
      defaultExpandedKeys: [],
      selectedKeys: [],
      treeSpin: false,
      token: localStorage.getItem('token'),
      editQuestion: false,
      editQuestionId: 0,
      parentId: null,
      questionTypeId: ''
    };
  },
  methods: {
    // 下载模板
    download() {
      let fileUrl = 'importQuestionExample.xlsx';
      axios.get(fileUrl, {   //静态资源文件夹public
        responseType: 'blob',
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        let fname = '企业常见问答导入模板.xls';
        link.href = url;
        link.setAttribute('download', fname);
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        console.log('error:' + JSON.stringify(error))
      });
    },
    // 导入 常见问题
    async importHandleChange({file}) {
      if (file.status === 'done') {
        if (file.response.code == 500) {
          console.log('error', file)
          this.$message.error('导入数据不规范,示范文件下载中...')
          let downFile = api.clue.ERROREXCEL + 'error/' + file.response.msg + "?download=1";
          axios.get(downFile, {responseType: "blob"})
              .then((res) => {
                const blob = new Blob([res.data], {
                  type: "application/vnd.ms-excel;charset=utf-8",
                });
                const href = window.URL.createObjectURL(blob);
                const downloadElement = document.createElement("a");
                downloadElement.href = href;
                var name = res.headers["content-disposition"];
                downloadElement.download = decodeURI(name.substring(name.lastIndexOf("=") + 1));
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(href);
              }).catch((fail) => {
            console.error(fail);
          });
          // window.URL.revokeObjectURL(href); //释放掉blob对象
        } else {
          console.log('success', file)
          this.$message.success('导入成功')
        }
        this.showImportPop = false;
        this.refresh();
      }
    },
    async getQuestionTree() {
      let deptList = await dataApi.getQuestionTree();
      this.allList = deptList.data;

      this.deptList = XEUtils.toArrayTree(deptList.data, {
        key: 'questionTypeId',
        parentKey: 'parentId',
        children: 'children'
      })
      console.log(this.deptList)
      // this.defaultExpandedKeys = deptList.data.map(val => {
      //   //默认只展开一级
      // })
    },
    /**
     * 选中树
     * @param selectedKeys
     */
    onSelect(selectedKeys) {
      this.selectedKeys = selectedKeys;
      this.questionTypeId = selectedKeys[0];

      this.$nextTick(() => {
        this.refresh()
      })
    },
    /**
     * 选择复选框
     * @param checkedKeys
     */
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys.checked;
    },
    add() {
      if (this.selectedKeys.length) {
        this.parentId = this.selectedKeys[0]
      } else {
        this.parentId = null
      }
      this.editQuestionId = 0
      this.editQuestion = true
    },
    edit() {
      if (this.selectedKeys.length) {
        this.editQuestionId = this.selectedKeys[0]
        this.editQuestion = true
      } else {
        this.$message.error('请选择问题分组')
      }
    },
    del() {
      const vm = this
      if (this.selectedKeys.length) {
        this.$confirm({
          title: '确定要删除分组吗',
          content: '',
          onOk() {
            vm.doDel()
          },
          onCancel() {
            console.log('Cancel');
          }
        });
      } else {
        this.$message.error('请选择问题分组')
      }
    },
    doDel() {
      dataApi.delQuestionTree(this.selectedKeys[0]).then(res => {
        if (res.code === 200) {
          this.$message.success('删除成功')
          this.getQuestionTree()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    closeQuestion(flag) {
      this.editQuestion = false
      if (flag) {
        this.getQuestionTree()
      }
    }
  },
};
</script>

<style scoped lang="less">
.left_tree {
  width: 20%;
  padding: 20px;
  float: left;
  height: calc(100vh - 48px - 64px);
  border-right: 1px solid #e0e0e0;
  background: #fff;
  overflow-y: auto;
}

.right_table {
  width: 80%;
  float: right;
  height: 100%;
}

///deep/ .ant-spin-container {
//  height: 100%;
//  display: flex;
//  flex-direction: column;
//}
///deep/ .ant-tree {
//  flex: 1;
//  overflow-y: scroll;
//}
</style>
